import React from "react";

const UserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.75 7.75H17C17 8.99264 15.9926 10 14.75 10V10.75V11.5C16.8211 11.5 18.5 9.82107 18.5 7.75H17.75ZM14.75 10.75V10C13.5074 10 12.5 8.99264 12.5 7.75H11.75H11C11 9.82107 12.6789 11.5 14.75 11.5V10.75ZM11.75 7.75H12.5C12.5 6.50736 13.5074 5.5 14.75 5.5V4.75V4C12.6789 4 11 5.67893 11 7.75H11.75ZM14.75 4.75V5.5C15.9926 5.5 17 6.50736 17 7.75H17.75H18.5C18.5 5.67893 16.8211 4 14.75 4V4.75ZM11.75 13.75V14.5H17.75V13.75V13H11.75V13.75ZM17.75 19.75V19H11.75V19.75V20.5H17.75V19.75ZM11.75 19.75V19C10.5074 19 9.5 17.9926 9.5 16.75H8.75H8C8 18.8211 9.67893 20.5 11.75 20.5V19.75ZM20.75 16.75H20C20 17.9926 18.9926 19 17.75 19V19.75V20.5C19.8211 20.5 21.5 18.8211 21.5 16.75H20.75ZM17.75 13.75V14.5C18.9926 14.5 20 15.5074 20 16.75H20.75H21.5C21.5 14.6789 19.8211 13 17.75 13V13.75ZM11.75 13.75V13C9.67893 13 8 14.6789 8 16.75H8.75H9.5C9.5 15.5074 10.5074 14.5 11.75 14.5V13.75Z"
        fill="white"
      />
      <path
        d="M10.5021 10.3887C10.3444 10.1353 10.0485 10 9.75 10C8.50736 10 7.5 8.99264 7.5 7.75C7.5 6.50736 8.50736 5.5 9.75 5.5C10.0485 5.5 10.3444 5.36473 10.5021 5.11135C10.5091 5.10014 10.5161 5.08896 10.5232 5.07782C10.7858 4.66331 10.6527 4.0764 10.165 4.0227C10.0287 4.0077 9.89027 4 9.75 4C7.67893 4 6 5.67893 6 7.75C6 9.82107 7.67893 11.5 9.75 11.5C9.89027 11.5 10.0287 11.4923 10.165 11.4773C10.6527 11.4236 10.7858 10.8367 10.5232 10.4222C10.5161 10.411 10.5091 10.3999 10.5021 10.3887Z"
        fill="white"
      />
      <path
        d="M7.45829 18.3169C7.34477 18.1275 7.14439 18 6.92359 18H6.75C5.50736 18 4.5 16.9926 4.5 15.75C4.5 14.5074 5.50736 13.5 6.75 13.5H6.92359C7.14439 13.5 7.34477 13.3725 7.45829 13.1831C7.73539 12.7208 7.43468 12 6.89569 12H6.75C4.67893 12 3 13.6789 3 15.75C3 17.8211 4.67893 19.5 6.75 19.5H6.89569C7.43469 19.5 7.73539 18.7792 7.45829 18.3169Z"
        fill="white"
      />
    </svg>
  );
};

export default UserIcon;
